import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { TextField } from '@material-ui/core';
import { getFieldLabel } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PublicProcurementObject(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: "card",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex-container",
      children: /*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.titles.publicProcurementObject"
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-12",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.publicProcurementData.publicProcurementObject', true),
          id: "publicProcurementObject",
          name: "publicProcurementObject",
          value: props.projectPublicProcurementData.publicProcurementObject || '',
          disabled: true
        })
      })
    })]
  });
}
PublicProcurementObject.propTypes = {
  projectPublicProcurementData: PropTypes.shape({
    publicProcurementObject: PropTypes.string
  }).isRequired
};
export default PublicProcurementObject;